import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { LangProvider } from "./context/LangContext";
import { AuthProvider } from "./context/AuthContext";
import { CartProvider } from "./context/CartContext";
import { StoreProvider } from "./context/StoreContext";
import { Header } from "./components/shop/Header";
import { Footer } from "./components/shop/Footer";
import { ScrollReveal } from "./components/ScrollReveal";
import { CartDrawer } from "./components/shop/CartDrawer";
import Home from "./pages/Home";
import Shop from "./pages/Shop";
import ProductDetail from "./pages/ProductDetail";
import Checkout from "./pages/Checkout";
import { PaymentSuccess, PaymentCancel } from "./pages/PaymentResult";
import AuthPage from "./pages/AuthPage";
import About from "./pages/About";
import Legal from "./pages/Legal";
import Admin from "./pages/Admin";
import Cart from "./pages/Cart";
import Join from "./pages/Join";
import Member from "./pages/Member";
import Community, { MemberPublic, EditProfile } from "./pages/Community";
import { ForgotPassword, ResetPassword, VerifyEmail } from "./pages/SecurityPages";

const ScrollTop = () => {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
};

function App() {
  return (
    <LangProvider>
      <StoreProvider>
      <AuthProvider>
        <CartProvider>
          <BrowserRouter>
            <ScrollTop />
            <ScrollReveal />
            <Header />
            <main>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/shop" element={<Shop />} />
                <Route path="/product/:slug" element={<ProductDetail />} />
                <Route path="/checkout" element={<Checkout />} />
                <Route path="/payment/success" element={<PaymentSuccess />} />
                <Route path="/payment/cancel" element={<PaymentCancel />} />
                <Route path="/login" element={<AuthPage mode="login" />} />
                <Route path="/register" element={<Navigate to="/join" replace />} />
                <Route path="/account" element={<Navigate to="/member/orders" replace />} />
                <Route path="/join" element={<Join />} />
                <Route path="/cart" element={<Cart />} />
                <Route path="/pokemon" element={<Shop />} />
                <Route path="/pokemon/:lang" element={<Shop />} />
                <Route path="/forgot-password" element={<ForgotPassword />} />
                <Route path="/reset-password" element={<ResetPassword />} />
                <Route path="/verify-email" element={<VerifyEmail />} />
                <Route path="/member" element={<Member />} />
                <Route path="/member/edit" element={<EditProfile />} />
                <Route path="/member/:tab" element={<Member />} />
                <Route path="/community" element={<Community />} />
                <Route path="/u/:handle" element={<MemberPublic />} />
                <Route path="/about" element={<About />} />
                <Route path="/legal/:page" element={<Legal />} />
                <Route path="/admin" element={<Admin />} />
              </Routes>
            </main>
            <Footer />
            <CartDrawer />
            <Toaster position="bottom-right" richColors />
          </BrowserRouter>
        </CartProvider>
      </AuthProvider>
      </StoreProvider>
    </LangProvider>
  );
}

export default App;
